
<template>
    <v-container fluid>        
        <v-layout row wrap>
            <v-flex xs12>

                <v-card>
                    <v-card-title>
                        <h2>
                            Marken API
                        </h2>

                    </v-card-title>
                   
                    <v-layout row>
                        <v-flex xs6 offset-xs1>
                            <v-layout row wrap>
                                <v-flex xs5>                                    
                                    <v-select                        
                                    label="Auswahl Types"                                
                                    dark              
                                    cache-items
                                    required
                                    v-bind:items="types"     
                                    item-text="name"
                                    item-value="id"
                                    return-object
                                    v-model="ccType"></v-select>                                                      
                                </v-flex>
                                <v-flex xs5 offset-xs1>
                                    <v-select                        
                                        label="Auswahl Client"                                
                                        dark                                               

                                        required
                                        v-bind:items="ccClients"     
                                        item-text="name"
                                        item-value="id"
                                        return-object
                                        v-model="ccClient"
                                        v-on:input="changeSelected()"></v-select>
                                </v-flex>                                
                            </v-layout>                                                            
                        </v-flex>                                        
                    </v-layout>
                    
                    <v-layout row>
                        <v-flex xs12>
                            <v-btn v-on:click="configAPI">
                                API konfigurieren
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    
                    <v-divider></v-divider>
                    <v-card-text>                                                                
                        <v-layout row>
                            <v-flex xs6 offset-xs6>
                                <v-text-field
                                    append-icon="search"
                                    label="Search"
                                    single-line
                                    hide-details
                                    v-model="tsearch"
                                    >

                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        
                        <v-data-table                               
                            v-model="selected"
                            v-bind:headers="headers"
                            v-bind:items="filteredMarken"
                            v-bind:search="tsearch"
                            select-all
                            v-bind:pagination.sync="pagination"
                            item-key="id"
                            class="elevation-0"
                            v-bind:rowsPerPageItems="[5,10,35,{text:'Alle', value:-1}]"
                            >

                            <template slot="headers" slot-scope="props">

                                <tr>
                                    <th>
                                        <v-checkbox
                                            primary
                                            hide-details
                                            v-on:click.native="toggleAll"
                                            v-bind:input-value="props.all"
                                            v-bind:indeterminate="props.indeterminate"
                                            >

                                        </v-checkbox>
                                    </th>

                                    <th 
                                        v-bind:align="header.align"
                                        v-for="header in props.headers" 
                                        v-bind:key="header.text"
                                        v-bind:class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                        v-on:click="changeSort(header.value)"
                                    >
                                    <v-icon>arrow_upward</v-icon>
                                        {{ header.text }}
                                    </th>
                                    <th></th>
                                </tr>
                            </template>
                            <template slot="items" slot-scope="props">
                                <tr v-bind:active="props.selected" v-on:click="props.selected=!props.selected">                            
                                    <td>
                                        <v-checkbox primary hide-details v-bind:input-value="props.selected">

                                        </v-checkbox>
                                    </td>

                                    <td>
                                        {{ props.item.apimarke.name }}
                                    </td>
                                    <td v-if="props.item.apimarke.firmen.length !==0">
                                        {{ props.item.apimarke.firmen[0].name }} <br>
                                        {{ props.item.apimarke.firmen[0].namezusatz }}
                                    </td>
                                    <td v-else></td>
                                    
                                    <td v-if="props.item.apimarke.firmen.length !==0 && props.item.apimarke.firmen[0].adressen.length !== 0">
                                        {{ props.item.apimarke.firmen[0].adressen[0].strasse }} <br>
                                        {{props.item.apimarke.firmen[0].adressen[0].plz }} {{props.item.apimarke.firmen[0].adressen[0].ort }}
                                    </td>
                                     <td v-else></td>
                                    <td>
                                        <p v-for="type in props.item.apimarke.types" v-bind:key="type.id">
                                            {{ type.name }}
                                        </p>                                            
                                    </td>
                                   
                                </tr>
                            </template>                   
                        </v-data-table>                            
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    
</template>

<script>
    import typesSelect from '../../shared/typesSelectSingle.vue'
    import clientsSelect from '../../shared/clientsSelectSingle.vue'
    
    export default {
        mounted () {
            this.initTypes()
            this.$store.dispatch('setMarken')     
            this.$store.dispatch('setApiMarken')     
            this.initCCClients()  
            
        },
        components: {
            'clients-select': clientsSelect,
            'types-select': typesSelect,
        },
        
        data() {
            return {
                pagination: {     
                    sortBy:'apimarke.name'
                },
                ccType:null,
                ccClient: null,
                tsearch:'',
                selected: [],
                headers: [
                    {text: 'Name', align: 'left', value: 'apimarke.name'},
                    {text: 'Firma', align: 'left', value: 'apimarke.firmen[0].name'},
                    {text: 'Adresse', align: 'left', value: 'apimarke.firmen[0].adressen[0].strasse'},
                    {text: 'Typen', align: 'left', value: 'apimarke.types[0].name'},
                ],                
                
            };
        },

        computed: {
            marken: function() { 
                return this.$store.getters.apimarken                
            },            
            loading: function() {
                return this.$store.getters.loading
            },
            ccClients: function() {            
                return this.$store.getters.ccClients
            },
            types: function() {            
                return this.$store.getters.types
            },            
            
            filteredMarken: function() {
               
                return this.marken.filter((m) => {                                        
                    if (this.ccType===null) {
                        return m.apitype.name.match(/.*/)
                    }
                    return m.apitype.name.match(this.ccType.name)
                    })
            },    
            exportMarken: function() {
                return this.selected.filter((s) =>{
                    return this.filteredMarken.some((fm)=>{
                        return s.id == fm.id
                    })
                })
                
            }
        },
        // TODO - Complete reworking this
        methods: {
            
            changeSelected () {                
                this.selected = this.ccClient.marketype.slice()
            },
            
            initCCClients (){
                
                this.$store.dispatch('setCCClients').then(()=>{
                    if (this.ccClients.length>0) {
                        if(this.ccClient===null) {
                            this.ccClient=this.ccClients[0]
                        }
                        this.changeSelected
                    }
                })  
            },
            initTypes (){
                this.$store.dispatch('setTypes').then(()=>{
                    if (this.types.length>0) {
                        if(this.ccType==null) {
                            this.ccType = this.types[0]     
                        }
                    }
                })  
            },
            toggleAll () {
                if (this.selected.length) this.selected = []
                else this.selected = this.filteredMarken.slice()
              },
            changeSort (column) {
                if (this.pagination.sortBy === column) {
                  this.pagination.descending = !this.pagination.descending
                } else {
                  this.pagination.sortBy = column
                  this.pagination.descending = false
                }              
            },
            
            configAPI: function() {
                                                
                let marken = []
                this.exportMarken.forEach((m)=>{
                    marken.push(m.apimarke)
                })
                this.$store.commit('setMessagebar', false)                             
                let data={
                    'marken': this.exportMarken,
                    'client_id': this.ccClient.id,
                    'type_id': this.ccType.id                
                }  
                this.$store.dispatch('postApiMarken', data)
                    .then((response)=>{ 
                        this.initCCClients()
                    })    
                this.$store.commit('setMessagebar', true)
            }            
        }
    }
</script>



// WEBPACK FOOTER //
// Markenapi.vue?72a01b0e